<template>
  <div id="contenedor-contratistas-main">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ContratistasMain',
  data() {
    return {};
  },
  mounted() {
    // console.log('ContratistasMain');
  },
};
</script>

<style lang="scss">

</style>
